import { RouteDataService } from './../../../services/route-data.service';
import { CommonService } from 'app/services/common.service';
import { WebService } from './../../../services/web.service';
import { NotificationService } from './../../../services/notification.service';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { LoginInfoProvider } from '../../../ev-dal/login-info.provider';
import { TableHead } from '../../../models';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-personal-bests',
  templateUrl: './personal-bests.component.html',
  styleUrls: ['../score.scss', './personal-bests.component.scss']
})
export class PersonalBestsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() studentProfileId: any;
  personalBests = [];
  profileId: string;

  tableHead: TableHead[] = [
    {title: 'Test', field: 'type', sort: false},
    {title: 'Best Score', field: 'best', sort: false},
    {title: 'Most Recent Score', field: 'last', sort: false},
    {title: 'Most Recent Test Date', field: 'bestTaken', sort: false}
  ];

  studentUserFlag: boolean;
  loader = false;
  routerSub: Subscription;

  constructor (
    private notificationService: NotificationService,
    private authService: LoginInfoProvider,
    private webService: WebService,
    private routeService: RouteDataService
  ) { }

  ngOnInit() {
    this.profileId = this.studentProfileId || this.authService.userId;

    if (!this.studentUserFlag) {
      this.getTestScoreData();
    }

    this.routerSub = this.routeService.testScoreUpdate.subscribe(() => {
      this.getTestScoreData();
    })
  }

  ngOnChanges() {
    if (this.profileId) {
      this.studentUserFlag = true;
      this.getTestScoreData();
      return;
    }

    this.studentUserFlag = false;
  }

  getTestScoreData() {
    this.loader = true;
    const inputJson = {
      studentUserId: this.profileId,
      partnerId: this.authService.partnerId,
      userId: this.authService.userId
    };

    this.webService.post('student/getBestScores', inputJson)
      .subscribe(
      (data: any) => {
        this.loader = false;
        this.personalBests = data.scores;
      },
      () => {
        this.loader = false;
        this.personalBests = [];
        this.notificationService.show('error', 'Error while fetching student best scores');
      });
  }

  ngOnDestroy() {
    this.routerSub.unsubscribe();
  }
}
